import { SearchDocumentType } from '@wix/client-search-sdk';

export const enum SearchRequestStatus {
  Initial,
  Loading,
  Loaded,
  Failed,
}

export interface ITab {
  documentType: SearchDocumentType;
  visible: boolean;
  count: number;
  title: string;
}
